/* global fitData */

(function () {
  'use strict';

  var id = 'correlation',
    corrMeasures = null;
  angular.module('wsLrs.cards').
  // All injectable services need to be named with a prefix (id) to "namespace" them since we are operating
  // within one global wsLrs module that's shared by all carts.
  factory(id + ".Utils", ["$filter", "ChartUtils", "Api", "$http", "CardQueryResource", "wsConstants", 'AggregationUtils', 'QueryES', '$templateRequest', 'wsConstants', 'wsColors', '$sanitize', function ($filter, ChartUtils, Api, $http, CardQueryResource, Const, AggUtils, QueryES, $templateRequest, wsConstants, wsColors, $sanitize) {
    var self = {
      ifData: function ifData(r) {
        return r && r.results && r.results[0] && r.results[0].result && r.results[0].result.data && !_.isEmpty(r.results[0].result.data);
      },
      dimension: '',
      fetchData: function fetchData(cardId, runRegression, cardToPreview, params) {
        params = params || {};
        params.runRegression = runRegression;
        var fetchCfg = {
          path: "/correlation/fetchData",
          cardId: cardId,
          cardToPreview: cardToPreview,
          params: params,
          progressChannel: 'correlation-' + cardId
        };

        // If this is a request for a regression, make sure the associated results are sampled
        // down to some sane size.
        if (fetchCfg.params.runRegression) {
          fetchCfg.params.sample = 1250;
        }
        return CardQueryResource.getWithProgress(fetchCfg);
      },
      ensureDataSize: function ensureDataSize($scope, data) {
        var underLimit = data.length < 3500;
        if (!underLimit) {
          $scope.hasData = false;
          $scope.noDataMsg = "Too many data points to display. Please narrow your results.";
        }
        return underLimit;
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      _tooltipTemplate: null,
      getCorrelationChart: function getCorrelationChart(data, cfg) {
        var x = cfg.x,
          y = cfg.y,
          config = cfg.config,
          stats = cfg.stats,
          outliers = cfg.outliers;
        var empty = ChartUtils.getEmptyChart();
        empty.lang.noData = "We are unable to display a visualization <br/>with the currently selected measures. <br/>Please make a different selection.";
        if (!data || _.isNull(x) || _.isNull(y)) {
          return empty;
        }
        var xDurationUnit = null,
          yDurationUnit = null,
          xName = $sanitize(config.measures[x].name),
          yName = $sanitize(config.measures[y].name),
          dimension = config.dimensions;
        var dimensionLabels = AggUtils.getDimensionLabels({
          config: config,
          context: 'chart'
        });
        var chart = {
          chart: {
            type: 'scatter'
          },
          title: {
            text: null
          },
          xAxis: {
            tickPositioner: function tickPositioner() {
              var intervals = null;
              if (this.chart.userOptions.info.xValProd.statementProperty === 'result.score.scaled') {
                // use custom tick intervals for % based measures
                intervals = [1, 5, 10, 20, 50, 100];
              }
              var ext = this.getExtremes();
              return ChartUtils.tickPositioner(this.width, 50, ext.dataMin, ext.dataMax, intervals);
            },
            title: {
              enabled: true,
              text: xName + ' by ' + dimensionLabels[0]
            },
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true,
            gridLineWidth: 1,
            labels: {
              formatter: function formatter() {
                var chartInfo = this.chart.userOptions.info;
                return AggUtils.getMeasureValueDisplay(this, chartInfo.xValProd);
              }
            }
          },
          yAxis: {
            tickPositioner: function tickPositioner() {
              var intervals = null;
              if (this.chart.userOptions.info.yValProd.statementProperty === 'result.score.scaled') {
                // use custom tick intervals for % based measures
                intervals = [1, 5, 10, 20, 50, 100];
              }
              var ext = this.getExtremes();
              return ChartUtils.tickPositioner(this.height, 40, ext.dataMin, ext.dataMax, intervals);
            },
            title: {
              text: yName + ' by ' + dimensionLabels[0]
            },
            labels: {
              formatter: function formatter() {
                var chartInfo = this.chart.userOptions.info;
                return AggUtils.getMeasureValueDisplay(this, chartInfo.yValProd);
              }
            }
          },
          plotOptions: {
            series: {
              events: {
                legendItemClick: null
              }
            },
            scatter: {
              marker: {
                symbol: 'circle',
                lineWidth: 1,
                lineColor: wsColors.wsGrayDark,
                states: {
                  hover: {
                    enabled: true,
                    lineWidth: 1,
                    lineColor: wsColors.wsGray
                  }
                }
              }
            }
          },
          tooltip: {
            headerFormat: '',
            _tooltipTemplate: this._tooltipTemplate,
            formatter: function formatter() {
              var tooltip = false;
              if (this.series.tooltipOptions.enabled) {
                var scope = {
                  name: this.series.chart.userOptions.info.formatter(this.point.name, this.series.chart.userOptions.info.dimension[0]),
                  xName: xName,
                  yName: yName,
                  xValue: this.series.chart.userOptions.info.measureFormatter({
                    value: this.point.x
                  }, this.series.chart.userOptions.info.xValProd),
                  yValue: this.series.chart.userOptions.info.measureFormatter({
                    value: this.point.y
                  }, this.series.chart.userOptions.info.yValProd),
                  series: this.series,
                  point: this.point
                };
                tooltip = _.template(this.series.tooltipOptions._tooltipTemplate)(scope);
              }
              return tooltip;
            }
          },
          series: [{
            name: $filter('capitalize')(dimensionLabels[0]),
            color: wsColors.getRGBA(wsColors.wsGrayLight, 0.5),
            showInLegend: true,
            data: []
          }, {
            name: 'Outlier',
            color: wsColors.getRGBA(wsColors.wsYellow, 0.5),
            showInLegend: true,
            data: []
          }],
          legend: {
            itemHoverStyle: {
              cursor: 'pointer'
            }
          },
          info: {
            formatter: AggUtils.getDimensionDisplay,
            dimension: dimension,
            measureFormatter: AggUtils.getMeasureValueDisplay,
            getDurationByUnit: this.getDurationByUnit,
            xValProd: config.measures[x],
            yValProd: config.measures[y]
          }
        };
        _.each(data, this.addMeasuresToChart, {
          chart: chart,
          x: x,
          y: y,
          outliers: _.union(outliers[x], outliers[y])
        });
        if (!chart.series[0].data) {
          return empty;
        }

        //make sure each axis has data
        var xValues = _.map(chart.series[0].data, function (item) {
            return item.x;
          }),
          yValues = _.map(chart.series[0].data, function (item) {
            return item.y;
          });
        if (xValues.length === 0 || yValues.length === 0) {
          return empty;
        }

        //after chart data is populated, determine the proper unit for any duration axes
        if (AggUtils.isDurationBasedMeasure(config.measures[x])) {
          xDurationUnit = config.measures[x].valueProducer.timePeriod || "milliseconds";
          chart.xAxis.title.text += " (" + xDurationUnit + ")";
        }
        if (AggUtils.isDurationBasedMeasure(config.measures[y])) {
          yDurationUnit = config.measures[y].valueProducer.timePeriod || "milliseconds";
          chart.yAxis.title.text += " (" + yDurationUnit + ")";
        }
        if (chart.series[0].data && chart.series[0].data.length > 1) {
          var r = fitData(_.union(chart.series[0].data, chart.series[1].data));
          if (r.slope) {
            chart.series.push({
              name: "",
              color: wsColors.wsGrayLight,
              tooltip: {
                enabled: false
              },
              showInLegend: false,
              type: 'line',
              zIndex: -9999,
              marker: {
                enabled: false,
                states: {
                  hover: {
                    enabled: false
                  }
                }
              },
              data: _.sortBy(r.data, function (d) {
                return d[0];
              })
            });
            if (stats) {
              stats.slope = r.slope;
            }
            if (stats && stats.pValues && stats.pValues[x][y] <= wsConstants.correlationThresholds.pValue && Math.abs(stats.correlation[x][y]) > wsConstants.correlationThresholds.coefficient) {
              chart.series[0].color = stats.correlation[x][y] > 0 ? ChartUtils.getSeriesColor(config, 0, wsColors.getRGBA(wsColors.wsBlue, 0.5)) : ChartUtils.getSeriesColor(config, 1, wsColors.getRGBA(wsColors.wsRed, 0.5));
            }
          }
        }

        //add benchmarks if they exists
        if (config.measures[x].benchmark && config.measures[y].benchmark) {
          var benchmark = {
            name: 'Benchmark',
            x: config.measures[x].benchmark.value,
            y: config.measures[y].benchmark.value
          };
          chart.series[0].benchmark = benchmark;
          chart.series[1].benchmark = benchmark;
          chart.series.push({
            name: 'Benchmark',
            color: wsColors.getRGBA(wsColors.wsPurple, 0.5),
            marker: {
              symbol: 'square'
            },
            showInLegend: true,
            data: [benchmark]
          });
        }
        return chart;
      },
      addMeasuresToChart: function addMeasuresToChart(val) {
        var x = val.aggregations[this.x],
          y = val.aggregations[this.y],
          name = val.values[0].label || val.values[0].value,
          id = val.values[0].value;
        if (x && y) {
          var xVal = x.value,
            yVal = y.value;
          if (typeof xVal !== "number" || typeof yVal !== "number") {
            return;
          }
          xVal = Math.round(xVal * 100) / 100;
          yVal = Math.round(yVal * 100) / 100;
          var isOutlier = this.outliers && _.contains(this.outliers, id);
          this.chart.series[isOutlier ? 1 : 0].data.push({
            name: name,
            x: xVal,
            y: yVal
          });
        }
      },
      getGroupTypes: function getGroupTypes(i) {
        return $http.get(Api.url('/group-types' + (i ? '/' + i : '')));
      },
      getDurationUnit: function getDurationUnit(data) {
        // data is in centiseconds
        var avgSeconds = _.reduce(data, function (memo, num) {
          return memo + num;
        }, 0) / (data.length === 0 ? 1 : data.length) / 100; // divide by 100 to convert to seconds

        if (avgSeconds <= Const.secondsPerMinute * 1.5) {
          return "seconds";
        }
        if (avgSeconds > Const.secondsPerMinute * 1.5 && avgSeconds <= Const.secondsPerHour * 1.5) {
          return "minutes";
        }
        if (avgSeconds > Const.secondsPerHour * 1.5 && avgSeconds <= Const.secondsPerDay * 1.5) {
          return "hours";
        }
        if (avgSeconds > Const.secondsPerDay * 1.5 && avgSeconds <= Const.secondsPerMonth * 1.5) {
          return "days";
        }
        if (avgSeconds > Const.secondsPerMonth * 1.5 && avgSeconds <= Const.secondsPerYear * 1.5) {
          return "months";
        }
        return "years";
      },
      getDurationByUnit: function getDurationByUnit(value, unit) {
        // value is in centiseconds
        value /= 100;
        if (unit === 'seconds') {
          return value;
        }
        if (unit === 'minutes') {
          return value / Const.secondsPerMinute;
        }
        if (unit === 'hours') {
          return value / Const.secondsPerHour;
        }
        if (unit === 'days') {
          return value / Const.secondsPerDay;
        }
        if (unit === 'months') {
          return value / Const.secondsPerMonth;
        }
        if (unit === 'years') {
          return value / Const.secondsPerYear;
        }
        return value;
      }
    };
    $templateRequest('modules/app/correlation/correlationTooltip.html').then(function (r) {
      self._tooltipTemplate = r;
    });
    return self;
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/correlation/:cardId', {
      templateUrl: 'modules/app/correlation/correlation-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/correlation/:cardId/top', {
      templateUrl: 'modules/app/correlation/correlation-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    //Register card icon preferences
    CardIconMap.register({
      "correlation": "correlation"
    });
  }]).controller(id + ".CardConfiguration", ["$scope", "$controller", 'Measures', '$rootScope', function ($scope, $controller, Measures, $rootScope) {
    $scope.tempMeasures = corrMeasures;
    $scope.templateType = id;
    $scope.getMeasures = Measures.getCorrelationMeasures;
    $scope.correlationHelpText = {
      helpTitle: 'Correlation',
      detailText: "In the Correlation section, you’ll choose what data measures you'd like to correlate " + "(using the Measures menu) and how you’d like to group them (using the Organized menu). To choose " + "measures, choose two different measures from the dropdown menus. Once measures are selected, use " + "the Organized menu to select how the data is organized."
    };
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });

    //clear out any listerMeasures on a new explore card event
    $rootScope.$on('explore-card', function () {
      corrMeasures = null;
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + ".Utils", '$window', 'AggregationUtils', 'wsEventNames', 'wsConstants', '$routeParams', 'ReportValidationService', function ($scope, CardRegistry, Utils, $window, AggUtils, wsEvents, wsConstants, $routeParams, ReportValidationService) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;

    // We don't want to sort correlation chart data
    $scope.config.defaultSort = undefined;
    $scope.dimensions = $scope.config.dimensions;
    $scope.x = $scope.config.measures[0];
    $scope.y = $scope.config.measures[1];
    $scope.helpLink = "https://watershedlrs.zendesk.com/hc?environment=" + $window.location.hostname;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var fetchParams = {
      required: "measure[0].value,measure[1].value",
      outlier: 2
    };
    Utils.fetchData($scope.card.id, true, $scope.cardToPreview, fetchParams).then(function (r) {
      if (Utils.ifData(r)) {
        // Advertise that the preview loaded, with the preview data
        if ($scope.cardToPreview) {
          $scope.$emit(wsEvents.card.preview.loaded, r);
        }
        var data = r.results[0].result.data;
        if (!Utils.ensureDataSize($scope, data)) {
          return;
        }
        $scope.stats = r.results[0].result.stats;
        $scope.regression = r.results[0].result.regression;
        $scope.dimension = AggUtils.getDimensionInSentence($scope.dimensions[0], $scope.stats.count !== 1);
        var outliers = _.chain(r.results[0].result.outliers).map(function (outs) {
          return _.chain(outs).pluck('dimensions').pluck('0').pluck('value').value();
        }).value();
        var cfg = {
          x: 0,
          y: 1,
          config: $scope.config,
          stats: $scope.regression,
          outliers: $scope.config.ignoreOutliers !== true ? outliers : []
        };
        $scope.correlationChart = Utils.getCorrelationChart(data, cfg);
        $scope.hasData = true;
      } else {
        $scope.hasData = false;
      }
    });
    $scope.abs = Math.abs;
    $scope.pValueThreshold = wsConstants.correlationThresholds.pValue;
    $scope.correlationThreshold = wsConstants.correlationThresholds.coefficient;
  }]).controller(id + ".Detail", ["$scope", "$routeParams", 'CardUtils', "CardRegistry", id + ".Utils", 'Api', 'CardQueryResource', 'AggregationUtils', 'wsConstants', 'wsColors', 'ReportValidationService', function ($scope, $routeParams, CardUtils, CardRegistry, Utils, Api, CardQueryResource, AggUtils, wsConstants, wsColors, ReportValidationService) {
    CardUtils.setNavElements($scope, $routeParams.cardId, $routeParams.cardId);
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($routeParams.cardId);
    $scope.config = $scope.card.configuration;

    // We don't want to sort correlation chart data
    $scope.config.defaultSort = undefined;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    $scope.cardToPreview = null;
    if ($routeParams.cardId === "preview") {
      $scope.cardToPreview = $scope.card;
    }

    //set up download data table link and pagenote download link
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('/correlation/csv', $routeParams.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
    $scope.measures = $scope.config.measures;
    $scope.xAxis = null;
    $scope.yAxis = null;
    $scope.correlationCoefficient = null;
    $scope.correlationHelpText = {
      helpTitle: 'How is correlation calculated?',
      detailText: "A correlation coefficient is a value used to measures the strength of the relationship between two variables. " + "We calculate the correlation using <a href='https://en.wikipedia.org/wiki/Pearson_product-moment_correlation_coefficient' target='_blank'>Pearson's correlation.</a> " + "Its value varies between -1 and +1. Values close to +1 are mean a strong positive correlation, values close to -1 mean a strong negative correlation, and values near 0 mean no correlation at all. " + " A strong positive correlation means the relationship between the variables is positive (i.e. when one variable goes up so does the other). " + "Negative values mean the relationship is negative. <br/><br/>" + "We also include the p value which measures the error in the statistical model. It is the probability that the two variables have nothing to do with each other. This number is between 0 and 1 and measures the accuracy of the correlation coefficient. " + "If the p value is very close to 0, that means that there is a high probability that the two variables are related and that the correlations coefficient is accurate. " + "If the p value is very close to 1, that means that there is a high probability that the two variables are NOT related and that the correlation coefficient is NOT accurate. "
    };
    var firstLoad = true;
    function fetchDetail() {
      var measureIdxA = $scope.measures.indexOf($scope.xAxis),
        measureIdxB = $scope.measures.indexOf($scope.yAxis);

      // Use sorted indices to avoid secondary fetch just for swapping
      // x and y axes.
      var sortedIndices = [measureIdxA, measureIdxB].sort();
      var fetchParams = {
        required: "measure[" + sortedIndices[0] + "].value," + "measure[" + sortedIndices[1] + "].value"
      };
      if (firstLoad) {
        fetchParams.outlier = 2;
      }
      $scope.getDimensionName = function (count) {
        return AggUtils.getDimensionInSentence($scope.config.dimensions[0], count !== 1);
      };
      $scope.sqrt = Math.sqrt;
      $scope.abs = Math.abs;
      $scope.correlationThreshold = wsConstants.correlationThresholds.coefficient;
      $scope.pValueThreshold = wsConstants.correlationThresholds.pValue;
      $scope.strongCoefficient = wsConstants.correlationThresholds.strongCoefficient;
      Utils.fetchData($scope.card.id, true, $scope.cardToPreview, fetchParams).then(function (r) {
        if (firstLoad) {
          if (Utils.ifData(r)) {
            if (!Utils.ensureDataSize($scope, r.results[0].result.data)) {
              return;
            }
            $scope.pagenote.setReportMetadata(r);
            if ($scope.config.ignoreOutliers !== true) {
              $scope.outliers = r.results[0].result.outliers;
              var outliersOnAllIds = _.map($scope.outliers[0], function (o) {
                return o.dimensions[0].value;
              });
              $scope.outliersOnAll = _.reduce($scope.outliers, function (all, out) {
                out = _.filter(out, function (o) {
                  return _.contains(outliersOnAllIds, o.dimensions[0].value);
                });
                outliersOnAllIds = _.map(out, function (o) {
                  return o.dimensions[0].value;
                });
                return out;
              }, []);
              $scope.outlierIds = _.chain($scope.outliers).map(function (outs) {
                return _.chain(outs).pluck('dimensions').pluck('0').pluck('value').value();
              }).value();
            } else {
              $scope.outliers = [];
              $scope.outliersOnAll = [];
              $scope.outlierIds = [];
            }
            $scope.benchmarks = r.results[0].result.benchmarksMet;

            //populate regression table
            $scope.defaultSortBy = "-p";
            $scope.regression = r.results[0].result.regression;
            if (!$scope.regression) {
              $scope.hasData = false;
              $scope.noDataMsg = "Unable to perform regression analysis on this data. Please select different dimensions and measures.";
              return;
            }
            var measures = $scope.config.measures;
            $scope.statistics = [];
            $scope.correlatedMeasures = [];
            for (var i = 0; i < measures.length; i++) {
              for (var j = i; j < measures.length; j++) {
                if (i === j) {
                  continue;
                }
                var m = {
                  x: measures[i].name,
                  y: measures[j].name,
                  p: $scope.regression.correlation[i][j],
                  pValues: $scope.regression.pValues[i][j],
                  fields: {
                    x: measures[i],
                    y: measures[j]
                  }
                };
                if (Math.abs(m.p) > wsConstants.correlationThresholds.coefficient && m.pValues < wsConstants.correlationThresholds.pValue) {
                  $scope.correlatedMeasures.push(m);
                }
                $scope.statistics.push(m);
              }
            }
            $scope.statistics = _.sortBy($scope.statistics, function (s) {
              return s[$scope.defaultSortBy.replace('-', '')];
            });
            if ($scope.defaultSortBy.lastIndexOf("-", 0) === 0) {
              $scope.statistics = $scope.statistics.reverse();
            }
            $scope.hasData = true;
          } else {
            $scope.hasData = false;
          }
          firstLoad = false;
        }
        if (Utils.ifData(r)) {
          $scope.data = r.results[0].result.data;
          $scope.regression = r.results[0].result.regression;
          $scope.stats = r.results[0].result.stats;
          $scope.corrChartDone = true;
          var cfg = {
            x: measureIdxA,
            y: measureIdxB,
            config: $scope.config,
            stats: $scope.regression,
            outliers: $scope.outlierIds
          };
          $scope.correlationCoefficient = $scope.regression.correlation[measureIdxA][measureIdxB];
          $scope.pValue = $scope.regression.pValues[measureIdxA][measureIdxB];
          $scope.correlationChart = Utils.getCorrelationChart($scope.data, cfg);
        }
      });
    }
    $scope.xAxis = $scope.measures[0];
    $scope.yAxis = $scope.measures[1];
    fetchDetail();
    $scope.getColor = function getColor() {
      if (Math.abs($scope.correlationCoefficient) > wsConstants.correlationThresholds.coefficient && $scope.pValue < wsConstants.correlationThresholds.pValue) {
        return $scope.correlationCoefficient > 0 ? wsColors.wsBlue : wsColors.wsRed;
      }
      return wsColors.wsGrayLight;
    };
    $scope.$on('correlationLister:rowSelected', function (event, row) {
      $scope.xAxis = row.fields.x;
      $scope.yAxis = row.fields.y;
      $scope.corrChartDone = null;
      fetchDetail();
    });
  }]).controller(id + ".CorrelationLister", ["$scope", "$routeParams", 'CardUtils', "CardRegistry", id + ".Utils", "$controller", "$q", "wsConstants", 'wsColors', function ($scope, $routeParams, CardUtils, CardRegistry, Utils, $controller, $q, wsConstants, wsColors) {
    $scope.measures = $scope.config.measures;
    $scope.defaultSortBy = "-p";
    $scope.sortControls = [{
      "title": "Measure 1",
      "options": {
        "Ascending": "y",
        "Descending": "-y"
      }
    }, {
      "title": "Measure 2",
      "options": {
        "Ascending": "x",
        "Descending": "-x"
      }
    }, {
      "title": "Correlation",
      "options": {
        "Ascending": "p",
        "Descending": "-p",
        'Ascending (Absolute)': '|p|',
        'Descending (Absolute)': '-|p|'
      }
    }, {
      "title": "Coefficient",
      "options": {
        "Ascending": "p",
        "Descending": "-p",
        'Ascending (Absolute)': '|p|',
        'Descending (Absolute)': '-|p|'
      }
    }, {
      "title": "P Value",
      "options": {
        "Ascending": "pValues",
        "Descending": "-pValues"
      }
    }, {
      "title": ""
    }];
    $scope.abs = Math.abs;
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    var firstLoad = true;
    $scope.fetchData = function fetchData(params) {
      var getCurrentList = function getCurrentList(params) {
        var limit = params._limit || params.limit || 10,
          offset = params._offset || 0,
          vals = _.values($scope.statistics);
        if (params.order_by) {
          var reverse = false;
          var orderBy = params.order_by;
          if (orderBy.lastIndexOf("-", 0) === 0) {
            orderBy = orderBy.substring(1, orderBy.length);
            reverse = true;
          }
          var orderByFunct = function orderByFunct(val) {
            // If it's the correlation coefficient, order by absolute value
            return orderBy === '|p|' ? Math.abs(val.p) : val[orderBy];
          };
          vals = _.sortBy(vals, orderByFunct);
          if (reverse) {
            vals.reverse();
          }
        }
        var numResults = _.size(vals);
        vals = vals.slice(offset, limit + offset);
        $scope.currentStatistics = vals;
        if (firstLoad) {
          firstLoad = false;
          $scope.selected = _.chain($scope.statistics).filter(function (s) {
            return s.x === this.name;
          }, $scope.measures[0]).filter(function (s) {
            return s.y === this.name;
          }, $scope.measures[1]).first().value();
        }
        return {
          "results": vals,
          "count": numResults
        };
      };
      if ($scope.statistics) {
        var deferred = $q.defer();
        deferred.resolve(getCurrentList(params));
        return deferred.promise;
      } else {
        $scope.statistics = $scope.$parent.statistics;
        return getCurrentList(params);
      }
    };
    /*jshint camelcase: true */

    $scope.correlationThreshold = wsConstants.correlationThresholds.coefficient;
    $scope.pValueThreshold = wsConstants.correlationThresholds.pValue;
    $scope.strongCoefficient = wsConstants.correlationThresholds.strongCoefficient;
    $scope.strongPValue = wsConstants.correlationThresholds.strongPValue;
    $scope.getColor = function getColor(m) {
      if (Math.abs(m.p) > wsConstants.correlationThresholds.coefficient) {
        return m.p > 0 ? wsColors.wsBlue : wsColors.wsRed;
      }
    };
    $scope.showOnChart = function showOnChart(row) {
      $scope.selected = row;
      $scope.$emit('correlationLister:rowSelected', row);
    };
  }]);
})();
